function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length); //the cvalue of the cookie
		}
	}
	return "";
}

function checkACookieExists(cname) {
	if (document.cookie.split(";").some((item) => item.trim().startsWith(cname + "="))) {
		return true;
	}

	return false;
}

function eraseCookie(cname) {
	setCookie(cname, "", -1);
}

var AdvancedProductConfig = class extends HTMLElement {
    constructor() {
      super();
      this.product = this.dataset.product;
      this.handle = this.dataset.handle;
      this.products = this.querySelectorAll('.product_advanced_features_item_product');
      this.productTitleHolder = this.querySelector('.product_advanced_features_item_title_variant');
      this.productPriceHolder = this.querySelector('.product_advanced_features_item_title_price');
      this.productRadios = this.querySelectorAll('.hidden_product_radio');
      this.productProps = this.querySelectorAll('.hidden_product_property');
      this.productAdditionalProps = this.querySelectorAll('.hidden_product_additional_property');
      this.productAdvancedQuantities = this.querySelectorAll('.hidden_product_advanced_quantity');
      this.productAdditionalLineItemProps = this.querySelectorAll('.hidden_product_line_item_property');
    }

  connectedCallback() {
    this.products.forEach((product) => {
      product?.addEventListener("click", this._onProductChanged.bind(this));
    });

    if(!this.classList.contains("is-product-card")) {
      const savedVariant = JSON.parse(localStorage.getItem("savedVariant"));
      if (savedVariant) {
        const customOption =
          savedVariant[this.product]?.customOptions?.[this.handle];
        if (customOption) {
          let element;
          if (customOption.variant)
            element = this.querySelector(
              `.product_advanced_features_item_product[data-variant="${customOption.variant}"]`
            );
          else if (customOption.product)
            element = this.querySelector(
              `.product_advanced_features_item_product[data-product="${customOption.product}"]`
            );
          element && this._onProductChanged({ currentTarget: element });
        }
      }
    }
  }

  disconnectedCallback() {
    this.products.forEach((product) => {
      product?.removeEventListener("click", this._onProductChanged);
    });
  }

    _onProductChanged(event) {
        if(event.preventDefault)event.preventDefault();
        const isNewDesign = this.dataset.newDesign;
        const product = event.currentTarget;
        const productTitle = product?.querySelector('.hidden_product_title');
        const productRadio = product?.querySelector('.hidden_product_radio');
        const productPrice = product?.querySelector('.hidden_product_price');
        const productProp = product?.querySelector('.hidden_product_property');
        const productAdditionalProp = product?.querySelector('.hidden_product_additional_property');
        const productAdvancedQuantity = product?.querySelector('.hidden_product_advanced_quantity');
        const productAdditionalLineItemProp = product?.querySelectorAll('.hidden_product_line_item_property');
        const productVariantTitle = product?.dataset.variantTitle;
        this._clearRadioChecks();
        this._clearActiveProductClasses();
        this.productTitleHolder.innerHTML = productTitle.value;
        !isNewDesign ? productPrice ? this.productPriceHolder.innerHTML = '+' + productPrice.value : '' : '';
        !isNewDesign ? productPrice ? this.productPriceHolder.classList.contains('hidden') && this.productPriceHolder.classList.remove('hidden') : '' : '';

        if(productRadio) {
          productRadio.checked = true;
          productRadio.focus({preventScroll: true})
        }
        if(productProp) {productProp.checked = true; productProp.focus({preventScroll: true})}
        if(productAdditionalProp) {productAdditionalProp.checked = true; productAdditionalProp.focus({preventScroll: true})}
        if(productAdvancedQuantity) {productAdvancedQuantity.checked = true; productAdvancedQuantity.focus({preventScroll: true})}
        if(productAdditionalLineItemProp){
          productAdditionalLineItemProp.forEach(prop => {
            prop.checked = true;
            prop.focus({preventScroll: true});
          });
        }
        product.classList.add("active");

        // const isTrustedClick = event.type === 'click' && event.isTrusted ? true : false;
        // if(window.location.pathname.includes('/pages/gaming') && !isTrustedClick) {
        //   window.scrollTo({ top: 0 });
        // }

        if(!isNewDesign) {
          const savedVariant = JSON.parse(localStorage.getItem("savedVariant"));
          const { product: productID, handle } = this;
          let newSavedVariant = savedVariant ? { ...savedVariant } : {};
          const value = {
            [handle]: {
              [product.dataset.variant ? "variant" : "product"]: product.dataset
                .variant
                ? product.dataset.variant
                : product.dataset.product,
                option: product.dataset.option,
            },
          };

          if (!newSavedVariant[productID]) {
            newSavedVariant[productID] = { customOptions: {} };
          }
          if (!newSavedVariant[productID].customOptions) {
            newSavedVariant[productID] = {
              ...newSavedVariant[productID],
              customOptions: {},
            };
          }
          newSavedVariant[productID].customOptions = {
            ...newSavedVariant[productID].customOptions,
            ...value,
          };
          localStorage.setItem("savedVariant", JSON.stringify(newSavedVariant));
        }

        const advancedPrices = this.closest('product-card')
        ? this.closest('product-card').querySelectorAll('.product_advanced_features_item_title_price')
        : this.closest('.product-info').querySelectorAll('.product_advanced_features_item_title_price');
        const cardPrice = this.closest('product-card')
        ? this.closest('product-card').querySelector('.pdp-total-price.custom_product_card_price')
        : this.closest('.product-info').querySelector('.pdp-total-price.custom_product_card_price');
        const buyBtnPrice = document.querySelector('buy-buttons .buy-btn-price');
        const buyBtnCompareAtPrice = document.querySelector('buy-buttons .buy-btn-compare-at-price');
        const stickyAddToCartPrice = document.querySelector('product-quick-add .custom_product_card_price');
        const stickyAddtoCartCompareAtPrice = document.querySelector('product-quick-add .compare-at-price');
        const stickyAddToCartText = document.querySelector('product-quick-add .product-quick-add-starting-at-text');
        const cardComparePrice = this.closest('product-card')
        ? this.closest('product-card').querySelector('compare-at-price .compare-at-price')
        : this.closest('.product-info').querySelector('compare-at-price .compare-at-price');

        setTimeout(() =>{
          let newPrice = parseFloat(cardPrice.getAttribute('data-original-price').replace(/,/g, ""));
          let newComparePrice = parseFloat(cardComparePrice.getAttribute('data-original-price').replace(/,/g, ""));
          let currency;

          for (const price of advancedPrices) {
            newPrice += parseFloat(price.textContent.replace(/,/g, ""));
            newComparePrice += parseFloat(price.textContent.replace(/,/g, ""));
            currency = price.textContent.split(' ')[1];
          }
          if (advancedPrices.length > 0) {

            cardPrice.textContent = `${newPrice.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits:2})} ${currency}`;
            const textUnderPriceEl = document.querySelector(".badge-under-price-wrapper");
            const textUnderPriceText = textUnderPriceEl?.querySelector(".badge-under-price__price");
            const percentageUnderPriceText = textUnderPriceEl?.querySelector(".badge-under-price__percent");
            const calculatedPrice = newComparePrice - newPrice;
            const calculatedPercentage = newComparePrice ? ((newComparePrice - newPrice) / newComparePrice) * 100 : '';
            newComparePrice
              ? (
                  cardComparePrice.textContent = `${newComparePrice.toLocaleString('un-US', {minimumFractionDigits: 0, maximumFractionDigits:2})} ${currency}`,
                  this.closest('product-card') ? ''
                  : (
                      buyBtnCompareAtPrice ? buyBtnCompareAtPrice.textContent = `${newComparePrice.toLocaleString('un-US', {minimumFractionDigits: 0, maximumFractionDigits:2})} ${currency}` : '',
                      stickyAddtoCartCompareAtPrice ? stickyAddtoCartCompareAtPrice.textContent = `${newComparePrice.toLocaleString('un-US', {minimumFractionDigits: 2, maximumFractionDigits:2})} ${currency}` : '',
                      textUnderPriceText && newComparePrice ? textUnderPriceText.textContent = `${calculatedPrice.toLocaleString("en-US",{ minimumFractionDigits: 0, maximumFractionDigits: 2 })} ${currency}` : '',
                      percentageUnderPriceText ? percentageUnderPriceText.textContent = `(-${Math.floor(calculatedPercentage)}%)` : ''
                    )
                )
              : '';
            this.closest('product-card') ? ''
            :
              (
                buyBtnPrice ? buyBtnPrice.textContent = `${newPrice.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits:2})} ${currency}` : '',
                stickyAddToCartPrice ? stickyAddToCartPrice.textContent = `${newPrice.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits:2})} ${currency}` : ''
              )

            if (stickyAddToCartText) {
              if (!this.closest('product-card')) {
                if (productTitle.value != 'Без' || productTitle.value != 'Без плот') {
                  stickyAddToCartText.classList.add('hidden');
                } else {
                  stickyAddToCartText.classList.remove('hidden');
                }
              }
            }

              this._updateGallery(productVariantTitle)
          }
      },0);

      if (isNewDesign) {
        const custom_event = new CustomEvent("advanced_variant_change", { bubbles: true, detail: product });
        this.dispatchEvent(custom_event);
      }
    }

    _clearRadioChecks(){
      const radios = [...this.productRadios, ...this.productProps, ...this.productAdditionalProps, ...this.productAdvancedQuantities, ...this.productAdditionalLineItemProps];
      radios.forEach(radio => {
        if(!radio) return;
        radio.checked = false
      });
    }

    _clearActiveProductClasses(){
        this.products.forEach(product => {
            product?.classList.remove("active")
        });
    }

    _updateGallery(variantTitle) {
      const variantPicker = document.querySelector('variant-picker');
      const galleryDots = document.querySelector('page-dots.product-gallery__thumbnail-list');
      const dots = galleryDots?.querySelectorAll('button');

      // Retrieve all legend and color elements
      let legends;
      let colors;
      if(variantPicker){
        legends = Array.from(variantPicker.querySelectorAll('legend:not(.advanced-feature-legend)')).map(legend => legend.textContent);
        colors = Array.from(variantPicker.querySelectorAll('variant-option-value')).map(color => color.textContent);
      }

      // Iterate over each dot and check if the alt attribute matches the condition
      if (legends != undefined){
        dots?.forEach(dot => {
          const image = dot.querySelector('img');
          const altText = image.getAttribute('alt');
          const expectedFormat = legends.map((legend, index) => `${legend} ${colors[index]}`).join(' | ');
          const altTextNoExpectedFormat = altText.replace(expectedFormat, '');

          if (altText.includes(expectedFormat) && altTextNoExpectedFormat.includes(variantTitle)) {
            dot.click();
          }
        });
      }
    }
};

if (!window.customElements.get("product-config")) {
  window.customElements.define("product-config", AdvancedProductConfig);
}

class AdvancedProduct extends HTMLElement{
  constructor() {
    super();
    const textComponent = this;
    const advancedProductVariants = JSON.parse(textComponent.querySelector('script[type="application/json"]').textContent);
    const colorSwatches = textComponent.querySelectorAll('.product_advanced_features_item_product.custom-color-swatch:not(:last-child)');
    const sizeSwatches = textComponent.querySelectorAll('.product_advanced_features_item_product.block-swatch');
    this.firstClick = false;


    textComponent.checkParameters(textComponent);

    document.addEventListener('advanced_variant_change', function(e){
      const product = e.detail;
      const productParentEl = product.closest('product-config');
      textComponent.setUnavailableVariants(product, sizeSwatches, colorSwatches, advancedProductVariants);
      textComponent.updateInfo(textComponent, advancedProductVariants, product, productParentEl);
    });
  }

  getLocalStorageVariant(element) {
    const savedVariant = JSON.parse(localStorage.getItem("savedVariant"));
    const prod = this.querySelector('.product_advanced_features_item_product').dataset.product;
    const prodHandle = this.querySelector('product-config').dataset.handle;
    if (savedVariant) {
      const customOption =
        savedVariant[prod]?.customOptions?.[prodHandle];
      if (customOption) {
        let element1;
        let element2;
        if (customOption.option1) {
          element1 = this.querySelector(
            `.product_advanced_features_item_product[data-option="${customOption.option1}"]`
          );
        }
        if (customOption.option2) {
          element2 = this.querySelector(
            `.product_advanced_features_item_product[data-option="${customOption.option2}"]`
          );
        }
        setTimeout(() => {
          element1 && element1.closest('product-config')._onProductChanged({ currentTarget: element1 });
          element2 && element2.closest('product-config')._onProductChanged({ currentTarget: element2 });
        },0);
      }
    } else {
      // const buttonWithout = element.querySelector(`.custom-color-swatch.button-without`);
      // setTimeout(() => {
      //   buttonWithout.closest('product-config')._onProductChanged({ currentTarget: buttonWithout });
      // }, 0);
    }
  }

  setLocalStorageVariant(parentElement, element, variantID, variantOption1, variantOption2) {
    const savedVariant = JSON.parse(localStorage.getItem("savedVariant"));
    const productID = element.dataset.product;
    let newSavedVariant = savedVariant ? { ...savedVariant } : {};
    const value = {
      [parentElement.dataset.handle]: {
        variant: variantID,
        option1: variantOption1,
        option2: variantOption2,
      },
    };

    if (!newSavedVariant[productID]) {
      newSavedVariant[productID] = { customOptions: {} };
    }
    if (!newSavedVariant[productID].customOptions) {
      newSavedVariant[productID] = {
        ...newSavedVariant[productID],
        customOptions: {},
      };
    }
    newSavedVariant[productID].customOptions = {
      ...newSavedVariant[productID].customOptions,
      ...value,
    };
    localStorage.setItem("savedVariant", JSON.stringify(newSavedVariant));
  }

  setUnavailableVariants(element, sizes, colors, allVariants) {
    if (element.classList.contains('custom-color-swatch') && !element.classList.contains('button-without')){
      // const selectedColor = element.dataset.option;

      // sizes.forEach((size) => {
      //   const available = allVariants.find((variant) => variant.option1 === selectedColor && variant.option2 === size.dataset.option && variant.available);
      //   if (!available) {
      //     size.classList.add('is-disabled');
      //   } else {
      //     size.classList.remove('is-disabled');
      //   }
      // });
    }
    if (element.classList.contains('block-swatch')){
      const selectedSize = element.dataset.option;

      colors.forEach((color) => {
        const available = allVariants.find((variant) => variant.option1 === color.dataset.option && variant.option2 === selectedSize && variant.available);
        if (!available) {
          color.classList.add('is-disabled');
        } else {
          color.classList.remove('is-disabled');
        }
      });
    }
  }

  updateInfo(element, allVariants, product, productParentEl) {
    const selectedVariants = element.querySelectorAll('.active');
    let currentVariantId;
    let currentVariantOption1;
    let currentVariantOption2;
    const color = selectedVariants[0];
    const size = selectedVariants[1];
    const allColorLineItems = color.querySelectorAll('input');
    const allSizes = size.closest('product-config').querySelectorAll('.block-swatch');
    const allColors = color.closest('product-config').querySelectorAll('.custom-color-swatch');
    const priceInput = color.querySelector('[name="product_price"]');
    const lineItemPriceInput = color.querySelector('.hidden_product_line_item_price');
    const optionPriceHolder = color.closest('.product_advanced_features_item')?.querySelector('.product_advanced_features_item_title_price');
    const idInput = color.querySelector('.hidden_product_variant_id');
    const currency = priceInput.value.split(' ').pop();
    const addToCartButton = document.querySelector("buy-buttons.buy-buttons .button");
    const addToCartButtonText = addToCartButton.querySelector(".buy-btn-content");
    const popup = this.closest("section").querySelector("inquery-popup");
    const mainProdSelectedVariant = this.closest('.product-info')?.querySelector('.variant-picker__option-values:not(.static)')?.querySelector('.input-checked');
    const mainProdSelectedVariantLabel = this.closest('.product-info')?.querySelector('.variant-picker__option-values:not(.static)')?.querySelector('input:checked + label');
    const mainProdSelectedVariants = this.closest('.product-info').querySelectorAll('.variant-picker__option-values');
    const freeDeliveryContainer = document.querySelectorAll('.free-delivery-container');
    const availabilityEl = this.closest('.product-info')?.querySelector('.product_status_availability');
    let isErgoPro = availabilityEl.dataset.isErgoproProduct;
    allVariants.forEach(variant => {
      if (variant.title.includes(color.dataset.option) && variant.title.includes(size.dataset.option)){
        currentVariantId = variant.id;
        currentVariantOption1 = variant.option1;
        currentVariantOption2 = variant.option2;

        if (variant.available){
          priceInput.value = `${(variant.price / 100).toLocaleString("en-US",{ minimumFractionDigits: 0, maximumFractionDigits: 2 })} ${currency}`;
          lineItemPriceInput.value = `${(variant.price / 100).toLocaleString("en-US",{ minimumFractionDigits: 0, maximumFractionDigits: 2 })} ${currency}`;
          optionPriceHolder.textContent = `+${(variant.price / 100).toLocaleString("en-US",{ minimumFractionDigits: 0, maximumFractionDigits: 2 })} ${currency}`;
          idInput.value = variant.id;
        } else {
          optionPriceHolder.textContent = `+0 ${currency}`;
        }
      }
    })


    let mainProdSelectedVariantsInputs = [];

    mainProdSelectedVariants.forEach(variant => {
      mainProdSelectedVariantsInputs.push(
        variant.querySelector('input:checked')
      );
      if(variant?.dataset.variantInventory > 0){
        mainProdSelectedVariantsAvaible = true;
      }
    })

    if(color.classList.contains('button-without')){
      element.updateParameters('clear', 'clear');
      optionPriceHolder.textContent = `+0 ${currency}`;
      // allColorLineItems.forEach(item => {
      //   item.checked = false;
      // });

      allSizes.forEach(size => {
        size.classList.add('is-visually-disabled');
        size.setAttribute('disabled', 'true');
        // const allSizeLineInputs = size.querySelectorAll('input');
        // allSizeLineInputs
        //   ? allSizeLineInputs.forEach(item => {
        //       item.checked = false;
        //     })
        //   : '';
      })
    }
    else {
      allSizes.forEach(size => {
        size.removeAttribute('disabled');
        size.classList.remove('is-visually-disabled');
        if (size.classList.contains('active')){
          let sizeOption = size.dataset.option;
          element.updateParameters(null, sizeOption);
          const allSizeLineInputs = size.querySelectorAll('input');
        allSizeLineInputs
          ? allSizeLineInputs.forEach(item => {
              item.checked = true;
            })
          : '';
        }
      })

      allColors.forEach(color => {
        if (color.classList.contains('active')){
          let colorOption = color.dataset.option;
          element.updateParameters(colorOption, null);
        }
      })
    }

    if(isErgoPro) {
      setTimeout(() => {
        const clonedAddToCartBtn = addToCartButton.cloneNode(true);
        clonedAddToCartBtn.querySelector(".buy-btn-content").innerHTML = window.themeVariables.strings.addToCartButton;
        clonedAddToCartBtn.classList.remove('inquery-btn');
        addToCartButton.replaceWith(clonedAddToCartBtn);

        freeDeliveryContainer.forEach(container => {
          container.classList.remove('hidden');
        })
      }, 0);
    }
    else if(color.classList.contains('is-disabled') || size.classList.contains('is-disabled') || mainProdSelectedVariant?.dataset.variantInventory <= 0){
      allColorLineItems.forEach(item => {
        item.checked = false;
      });
      addToCartButton.classList.add("inquery-btn");
      addToCartButton.addEventListener(
        "click",
        popup.showPopup.bind(popup)
      );
      addToCartButton.setAttribute("data-inquiry-btn", "true");
      addToCartButtonText.innerHTML = window.themeVariables.strings.inquiryButton;

      freeDeliveryContainer.forEach(container => {
        container.classList.add('hidden');
      })
    } else {
      allColorLineItems.forEach(item => {
        item.checked = true;
      });
      setTimeout(() => {
        const clonedAddToCartBtn = addToCartButton.cloneNode(true);
        clonedAddToCartBtn.querySelector(".buy-btn-content").innerHTML = window.themeVariables.strings.addToCartButton;
        clonedAddToCartBtn.classList.remove('inquery-btn');
        addToCartButton.replaceWith(clonedAddToCartBtn);

        freeDeliveryContainer.forEach(container => {
          container.classList.remove('hidden');
        })
      }, 0)
    }

    if(mainProdSelectedVariantsInputs.length > 1){
      setTimeout(() => {
        // Store current scroll position
        const currentScroll = window.scrollY;
        if(mainProdSelectedVariant) mainProdSelectedVariant.checked = false;

        // Add preventScroll option to click event
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
          preventScroll: true
        });
        mainProdSelectedVariantLabel?.dispatchEvent(clickEvent);
        // Dispatch change event with preventScroll
        const changeEvent = new Event('change', {
          bubbles: true,
          cancelable: true
        });
        mainProdSelectedVariant?.dispatchEvent(changeEvent);

        if(!this.firstClick){
          this.firstClick = true;
          // Create and dispatch a synthetic click event with preventScroll
          const productClickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
            preventScroll: true
          });
          product.dispatchEvent(productClickEvent);
        }

        // Restore scroll position
        window.scrollTo({
          top: currentScroll,
          behavior: 'instant'
        });
      }, 0)
    }

    element.setLocalStorageVariant(productParentEl, product, currentVariantId, currentVariantOption1, currentVariantOption2);
  }

  updateParameters(color, size) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (color == 'clear') {
      params.delete('top-color');
    }

    if (size == 'clear') {
      params.delete('top-size');
    }

    if (color && color != "clear") {
        params.set('top-color', color);
    }
    if (size && size != "clear") {
        params.set('top-size', size);
    }

    url.search = params.toString();
    window.history.replaceState({}, '', url);
  }

  checkParameters(element) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    const topColor = params.get('top-color');
    const topSize = params.get('top-size');

    if (topColor) {
      const colorSwatch = element.querySelector(`.custom-color-swatch[data-option="${topColor}"]`);
      if (colorSwatch) {
        setTimeout(() => {
          colorSwatch.closest('product-config')._onProductChanged({ currentTarget: colorSwatch });
        }, 0);
      }
    }

    if (topSize) {
      const sizeSwatch = element.querySelector(`.block-swatch[data-option="${topSize}"]`);
      if (sizeSwatch) {
        setTimeout(() => {
          sizeSwatch.closest('product-config')._onProductChanged({ currentTarget: sizeSwatch });
        }, 0);
      }
    }

    if (topColor == null && topSize == null) {
      element.getLocalStorageVariant(element);
    }
  }
}

if (!window.customElements.get("advanced-product")) {
  window.customElements.define("advanced-product", AdvancedProduct);
}

class MobileSort extends HTMLElement{
  constructor() {
    super();
    this.sortBtn = this.querySelector('.sort-button');
    this.filtersContent = this.querySelector('.mobile_filters__content');
  }

  toggleModal() {
    this.sortBtn.classList.toggle('open');
    this.filtersContent.classList.toggle('open');
  }

  connectedCallback(){
    this.sortBtn.addEventListener('click', this.toggleModal.bind(this));
  }
};

if (!window.customElements.get("mobile-sort")) {
  window.customElements.define("mobile-sort", MobileSort);
}

// Progress bar animation
class ProgressBarObserver {
  constructor(selector, observerOptions) {
    this.elementsToWatch = document.querySelectorAll(selector);
    this.observerOptions = observerOptions;
    this.callback = (entries, observer) => {
      entries.forEach((entry) => {
        const elementToWatch = entry.target;

        if (entry.isIntersecting) {
          elementToWatch.classList.add("progressbar_animation");
          elementToWatch.setAttribute("aria-valuenow", "100");
          elementToWatch.style.setProperty("--value", "100");
        } else {
          elementToWatch.classList.remove("progressbar_animation");
          elementToWatch.setAttribute("aria-valuenow", "0");
          elementToWatch.style.setProperty("--value", "0");
        }
      });
    };

    // Create an Intersection Observer instance for each element
    this.elementsToWatch.forEach((element) => {
      const observer = new IntersectionObserver(
        this.callback,
        this.observerOptions
      );
      observer.observe(element);
    });
  }
}

// Create an instance of the ProgressBarObserver class with the selector for progress bars
const progressBarObserver = new ProgressBarObserver('div[role="progressbar"]', {
  root: null, // Use the viewport as the root
  rootMargin: "0px", // No margin
  threshold: 0.2, // 0.2 means when 20% or more of the element is visible
});

// Page background transition and container fade animation
class PageBackgroundTransitionObserver {
  constructor(pageIdentifier, container, observerOptions) {
    this.pageIdentifier = pageIdentifier.toLowerCase();
    this.observerOptions = observerOptions;
    this.container = container;

    document.addEventListener("DOMContentLoaded", () => {
      this.initialize();
    });
  }

  initialize() {
    const currentPageURL = window.location.href;

    if (currentPageURL.toLowerCase().includes(this.pageIdentifier)) {
      this.setupMain();
      this.setupSections();
      this.setupIntersectionObserver();
    }
  }

  setupMain() {
    const main = document.querySelector("main");
    main.classList.add("background_transition__smooth");
    this.main = main;
  }

  setupSections() {
    const sections = this.main.querySelectorAll("section");

    sections.forEach((section) => {
      section.classList.add("no_section__background");
    });
  }

  setupIntersectionObserver() {
    const sectionsWithBackgroundColor = document.querySelectorAll(
      "[data-background-color]"
    );

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const backgroundColor = entry.target.getAttribute(
            "data-background-color"
          );
          this.main.style.backgroundColor = backgroundColor;

          // Show and animate the div
          const container = entry.target.querySelector(this.container);
          if (container) {
            container.style.opacity = "1";
            container.removeAttribute("unselectable", "on");
          }
        } else {
          // Hide and animate the div
          const container = entry.target.querySelector(this.container);

          if (container) {
            container.style.opacity = "0";
            container.setAttribute("unselectable", "on");
          }
        }
      });
    }, this.observerOptions);

    sectionsWithBackgroundColor.forEach((section) => {
      observer.observe(section);
    });
  }
}

// Create an instance of the class with the specified page identifier and options
const ergonomicsPage = new PageBackgroundTransitionObserver(
  "ergonomics",
  ".ergonomics-step_text__container",
  {
    root: document.querySelector("#scrollArea"),
    rootMargin: "80px",
    threshold: 0.90,
  }
);

const stickyPrice = document.querySelector('.sticky-price .product-info__price');
if (stickyPrice != undefined) {
  const stickyImage = document.querySelector('.shopify-section--main-product .product-gallery-sticky');
  const headerHeight = document.querySelector('store-header.header').offsetHeight;
  stickyPrice.style.top = `${headerHeight}px`;
  if (stickyImage) {
    stickyImage.style.top = `${headerHeight}px`;
  }
}

document.querySelector('.read_more_table')?.addEventListener('click', function() {
  const tableRows = document.querySelectorAll('.product_specs_table_row');
  for (const row of tableRows) {
      row.classList.remove('hidden');
  }
  this.classList.add('hidden');
})

if (checkACookieExists("thank_you")) {
  const thankYouAll = document.querySelectorAll('.thank-you-text');
  for (const thankYou of thankYouAll) {
    thankYou.classList.remove('hidden');
  }
}

if (checkACookieExists("inquery_thank_you")) {
  const inqueryThankYouAll = document.querySelectorAll('.inquery-thank-you-text');
  for (const inqueryThankYou of inqueryThankYouAll){
    inqueryThankYou.classList.remove('hidden');
  }
}

if (checkACookieExists("custom_image_with_content_overlay_thank_you")) {
  const customIimageWithContentOverlayThankYouAll = document.querySelectorAll('.custom_image_with_content_overlay--thank-you-text');
  for (const customIimageWithContentOverlayThankYou of customIimageWithContentOverlayThankYouAll){
    customIimageWithContentOverlayThankYou.classList.remove('hidden');
  }
}

const inqueryThankYouSubmit = document.querySelectorAll('.inquery-thank-you-submit');
  for (const inqueryTthankYou of inqueryThankYouSubmit) {
    inqueryTthankYou.addEventListener('click', function() {
      setCookie('inquery_thank_you', 'inquery_thank_you', 0.0006944444)
  })
}

const thankYouSubmit = document.querySelectorAll('.thank-you-submit');
  for (const thankYou of thankYouSubmit) {
    thankYou.addEventListener('click', function() {
      setCookie('thank_you', 'thank_you', 0.0006944444)
  })
}

const customIimageWithContentOverlaySubmit = document.querySelectorAll('.custom_image_with_content_overlay--thank-you-submit');
for (const thankYouSubmitBtn of customIimageWithContentOverlaySubmit) {
  thankYouSubmitBtn.addEventListener('click', function() {
    setCookie('custom_image_with_content_overlay_thank_you', 'custom_image_with_content_overlay_thank_you', 0.0006944444)
  })
}

const submitBtn = document.querySelector('button.button[type=submit]');
const checkMark = document.createElement('span');
checkMark.innerHTML = `
<svg
role="presentation"
focusable="false"
stroke-width="2"
width="32"
height="32"
class="icon-success-no-bg"
style="--icon-height: 32px"
viewBox="0 0 18 18"
>
<path d="M5 8.8L7.62937 11.6L13 6" stroke="currentColor" fill="none"></path>
</svg>
`;
submitBtn?.appendChild(checkMark);

/* code bellow is for the advanced swatches in collection page - needs to be moved to another file/reworked */
let imageElements = document.getElementsByClassName('product-card-image');

let swatches = document.querySelectorAll('.product-card__swatch-list input');
let productCardElements = document.querySelectorAll('product-card');
let triggerClickCardElement = document.querySelectorAll('.product_advanced_features_item_product_click')

function updateImages(productCardElement, variantTitle) {
  let defaultSwatchValue = productCardElement.querySelector('fieldset.product-card__swatch-list')?.dataset.optionName;
  defaultSwatchValue = defaultSwatchValue + productCardElement.querySelector('fieldset.product-card__swatch-list > input:checked')?.value ;
  let advancedSwatchValue = productCardElement.querySelector('product-config button.active .hidden_product_title')?.value;
  let imageElements = productCardElement.getElementsByClassName('product-card-image');

  let lastDisplayedImageWrapper = null;

  for (let i =  0; i < imageElements.length; i++) {
    let wrapper = imageElements[i].closest('.product-card-image-wrapper');
    if (wrapper.style.display !== 'none') {
      lastDisplayedImageWrapper = wrapper;
    }
    wrapper.style.display = 'none';
  }

  let allSwatchesMatch = false;
  let imageFoundAndDisplayed = false;

  for (let i =  0; i < imageElements.length; i++) {
    let altText = imageElements[i].getAttribute('alt');
    if (defaultSwatchValue) {
      if (altText.includes(defaultSwatchValue) && altText.includes(advancedSwatchValue)) {
        allSwatchesMatch = true;
      }
    } else {
      if (altText.includes(advancedSwatchValue)) {
        allSwatchesMatch = true;
      }
    }

    if (allSwatchesMatch && altText.includes(variantTitle)) {
      imageElements[i].closest('.product-card-image-wrapper').style.display = 'block';
      if (imageElements[i].closest('.product-card-image-wrapper').classList.contains('hidden_image')){
        imageElements[i].closest('.product-card-image-wrapper').classList.remove('hidden_image');
      }
      imageFoundAndDisplayed = true;
      break;
    }
  }

  if (!imageFoundAndDisplayed && lastDisplayedImageWrapper) {
    lastDisplayedImageWrapper.style.display = 'block';
  }
}

function customUpdateImages(swatch) {
  const productContainer = swatch.closest('product-card');
  const variantsData = JSON.parse(productContainer.querySelector('[data-variants-json]').textContent);

  const swatchFieldsets = productContainer.querySelectorAll('.product-card__swatch-list');
  const selectedOptions = {};

  swatchFieldsets.forEach(fieldset => {
    const optionPosition = fieldset.getAttribute('data-option-position');
    const selectedSwatch = fieldset.querySelector(':checked');

    if (selectedSwatch) {
      selectedOptions[`option${optionPosition}`] = selectedSwatch.value;
    }
  });

  const variant = variantsData.find(variant => {
    return Object.entries(selectedOptions).every(([option, value]) =>
      variant[option] === value
    );
  });

  if (variant && variant.featured_image) {
    const imageContainer = productContainer.querySelector('.product-card-image-wrapper');

    if (imageContainer) {
      const productImage = imageContainer.querySelector('.product-card-image');
      const productImagePicture = productImage.parentElement;

      const newImage = productImage.cloneNode(true);
      newImage.src = variant.featured_image.src;
      newImage.srcset = '';

      if (productImagePicture && productImagePicture.tagName === 'PICTURE') {
        const newPicture = productImagePicture.cloneNode(true);
        newPicture.querySelector('source').srcset = '';
        newPicture.replaceChild(newImage, newPicture.querySelector('.product-card-image'));
        productImagePicture.parentNode.replaceChild(newPicture, productImagePicture);
      } else {
        productImage.parentNode.replaceChild(newImage, productImage);
      }
    }
  }
}

swatches.forEach(function(swatch) {
  swatch.addEventListener('change', function() {
    let productCardElement = this.closest('product-card');
    let variantTitle = productCardElement.querySelector('.product_advanced_features_item_product.active')?.dataset.variantTitle || 'none';
    const isAdvancedSwatchesProduct = productCardElement.classList.contains('product-with-advanced-swatches');

    if (isAdvancedSwatchesProduct) {
      setTimeout(() => {
        updateImages(productCardElement, variantTitle);
      }, 0);
    } else {
      setTimeout(() => {
        customUpdateImages(swatch);
      }, 0);
    }
  });
});

productCardElements.forEach(function(productCardElement) {
  let buttonElements = productCardElement.querySelectorAll('.product_advanced_features_item_product');
  buttonElements.forEach(function(buttonElement) {
    buttonElement.addEventListener('click', function() {
      let variantTitle = this.dataset.variantTitle || 'none';
      updateImages(productCardElement, variantTitle);
    });
  });
});

// commented this as the click itself causes price calculation on the collection cards on initial load and the client doesn't want that
// triggerClickCardElement.forEach((toClick)=> {
//   toClick.click();
// })

// code below is for new search input in header
class HeaderSearch extends HTMLElement{
  constructor() {
    super();
    this.clearBtn = this.querySelector('button[is=clear-button]');
    this.mobileCloseBtn = this.querySelector('.mobile-close-btn');
    this.predictiveSearch = document.querySelector('predictive-search');
    this.searchDrawer = this.predictiveSearch.closest('search-drawer');
    this.input = this.querySelector('input');
    this.delimeter = this.querySelector('.search-form-delimeter');
  }

  click(){
    setTimeout(() => {
      if(this.searchDrawer.getAttribute('open') != null){
        this.mobileCloseBtn != null ? this.mobileCloseBtn.style.display = "block" : '';
      } else {
        this.mobileCloseBtn != null ? this.mobileCloseBtn.style.display = "none" : '';
      }
    }, 0);
  }

  onInputChanged() {
    if(this.input.value != ''){
      this.clearBtn.style.display = "block";
      this.delimeter.style.display = "block";
    } else {
      this.clearBtn.style.display = "none";
      this.delimeter.style.display = "none";
    }

    this.searchDrawer.getAttribute('open') == null ?  this.searchDrawer.setAttribute('open' , '') : '';
  }

  clearSearchInput() {
    this.input.value = '';
    this.onInputChanged();
    this.predictiveSearch._onInputChanged();
  }

  closeModal() {
    this.searchDrawer.getAttribute('open') != null ?  this.searchDrawer.removeAttribute('open') : '';
    this.mobileCloseBtn != null ? this.mobileCloseBtn.style.display = "none" : '';
  }

  connectedCallback(){
    this.clearBtn.addEventListener('click', this.clearSearchInput.bind(this));
    this.mobileCloseBtn != null ? this.mobileCloseBtn.addEventListener('click', this.closeModal.bind(this)) : '';
    this.input.addEventListener('input', this.onInputChanged.bind(this));
    this.input.addEventListener('change', this.onInputChanged.bind(this));
    this.input.addEventListener('click', this.click.bind(this));
  }
};

if (!window.customElements.get("header-search")) {
  window.customElements.define("header-search", HeaderSearch);
}

class ChangeQuantity extends HTMLElement {
  constructor() {
    super();
    this.quantityWrapper = this.closest('.quantity-input-wrapper');
    this.quantityInput = this.quantityWrapper?.querySelector('.quantity-input');
    this.lineItemQuantity = this.closest('line-item-quantity');
  }

  incrementQuantity() {
    if (!this.hasAttribute("disabled")) {
      const currentValue = parseInt(this.quantityInput.value);
      this.quantityInput.value = currentValue + 1;
      this.lineItemQuantity._changeLineItemQuantity(this.getAttribute("data-line-key"), parseInt(this.quantityInput.value));
    }
  }

  decrementQuantity() {
    if (!this.hasAttribute("disabled")) {
      const currentValue = parseInt(this.quantityInput.value);
      if (currentValue > 0) {
        this.quantityInput.value = currentValue - 1;
        this.lineItemQuantity._changeLineItemQuantity(this.getAttribute("data-line-key"), parseInt(this.quantityInput.value));
      }
    }
  }

  connectedCallback() {
    if (this.dataset.action == 'increment'){
      this.addEventListener('click', this.incrementQuantity.bind(this));
    }

    if (this.dataset.action == 'decrement'){
      this.addEventListener('click', this.decrementQuantity.bind(this));
    }
  }
}

if (!window.customElements.get("change-quantity")) {
  window.customElements.define("change-quantity", ChangeQuantity);
}

// open cart drawer initially if href has #cart-open
window.addEventListener("pageshow", () => {
  window.location.href.includes('#cart-open') ? document.querySelector('.cart-drawer')?.show() : "";
});

//mobile close btn close the menu
const mobileMegamenuCloseBtn = document.querySelector('.header .drawer_button__change');
mobileMegamenuCloseBtn.addEventListener('click', () => {
  document.querySelector('.navigation-drawer').removeAttribute('open');
})

// for the two close buttons in the predictive search results
document.addEventListener('click', function(event) {
  if(event.target.matches('.search-drawer-close-btn.hide-desktop')){
    document.querySelector('search-drawer').removeAttribute('open');
  }
})
